<template>
  <a-loading :loading="gameMeta.loading">
    <game-form
      mode="edit"
      :game="game"
      @submit="handleSubmit"
      @delete="handleDelete"
    />
  </a-loading>
</template>

<script>
  import { GameForm } from '@/components'
  import { useDeleteGame, useEditGame, useGame } from './gameHooks'
  import { ALoading } from 'codefabrik-gui-vue'

  export default {
    name: 'EditGame',
    components: { GameForm, ALoading },
    mixins: [
      useGame('game'),
      useEditGame('handleSubmit'),
      useDeleteGame('handleDelete')
    ]
  }
</script>

<style scoped>

</style>
